import { usePermissionHandler } from '@/hooks/usePermissionHandler';

export function PermissionRouterGuard({
  children,
}: {
  children: React.ReactNode;
}) {
  usePermissionHandler();
  return <>{children}</>;
}
